import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { Button } from "@material-ui/core";
import { PageControl } from "./styles";

interface Props {
  onAddClick: () => void;
}

const Controls = ({ onAddClick }: Props) => {
  return (
    <PageControl>
      <Button
        variant="contained"
        color="primary"
        startIcon={<AddIcon />}
        onClick={onAddClick}
      >
        Add Trivia
      </Button>
    </PageControl>
  );
};

export default Controls;
